import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_MESSAGE_HANDLER_URL;

class ShoppingListTrackingService {
  // Track when shopping list page is viewed

  constructor() {
    this.sessionId = this.getOrCreateSessionId();
    this.visitorId = this.getOrCreateVisitorId();
  }

  /**
   * Get or create a session ID
   * Session ID should be regenerated on page refresh/reload
   */
  getOrCreateSessionId() {
    // Generate new session ID on every page load (refresh creates new session)
    let newSessionId = sessionStorage.getItem('session_id');
    if(!newSessionId)
      {
    newSessionId = this.generateUUID();
    sessionStorage.setItem('session_id', newSessionId);
    console.log('New session created:', newSessionId);
      }
    return newSessionId;
  }

  /**
   * Get or create visitor ID (persists across sessions)
   */
  getOrCreateVisitorId() {
    let visitorId = localStorage.getItem('visitor_id');
    if (!visitorId) {
      visitorId = this.generateUUID();
      localStorage.setItem('visitor_id', visitorId);
      console.log('New visitor ID created:', visitorId);
    }
    return visitorId;
  }

  generateUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      const r = Math.random() * 16 | 0;
      const v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  getSessionId() {
    return this.sessionId;
  }

  getVisitorId() {
    return this.visitorId;
  }

  /**
   * Track shopping list view
   */
  async trackListView(phoneNumber, listId, categoriesData) {
    try {
      const response = await fetch(`${API_BASE_URL}/api/track/shopping-list-view`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          phone_number: phoneNumber,
          visitor_id: this.visitorId,
          session_id: this.sessionId,
          list_id: listId,
          categories_data: categoriesData
        })
      });

      const data = await response.json();
      console.log('List view tracked:', data);
      return data;
    } catch (error) {
      console.error('Error tracking list view:', error);
    }
  }

 /**
   * Track quantity selection
   */
  async trackQuantitySelection(phoneNumber, listId, productData) {
    try {
      const response = await fetch(`${API_BASE_URL}/api/track/quantity-selection`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          phone_number: phoneNumber,
          visitor_id: this.visitorId,
          session_id: this.sessionId,
          list_id: listId,
          product_data: productData
        })
      });

      const data = await response.json();
      console.log('Quantity selection tracked:', data);
      return data;
    } catch (error) {
      console.error('Error tracking quantity selection:', error);
    }
  }

   /**
   * Track Amazon button click
   */
  async trackAmazonButtonClick(phoneNumber, listId, clickData,store) {
    try {
      const response = await fetch(`${API_BASE_URL}/api/track/amazon-button-click`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          phone_number: phoneNumber,
          visitor_id: this.visitorId,
          session_id: this.sessionId,
          list_id: listId,
          click_data: clickData,
          store:store
        })
      });

      const data = await response.json();
      console.log('Amazon button click tracked:', data);
      return data;
    } catch (error) {
      console.error('Error tracking Amazon button click:', error);
    }
  }

  /**
   * Track page visit
   */
  async trackPageVisit(phoneNumber, pageId, keywords) {
    try {
      const response = await fetch(`${API_BASE_URL}/api/track/page-visit`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          phone_number: phoneNumber,
          visitor_id: this.visitorId,
          session_id: this.sessionId,
          page_id: pageId,
          keywords: keywords
        })
      });

      const data = await response.json();
      console.log('Page visit tracked:', data);
      return data;
    } catch (error) {
      console.error('Error tracking page visit:', error);
    }
  }

  /**
   * Track product click
   */
  async trackProductClick(phoneNumber, productData) {
    try {
      const response = await fetch(`${API_BASE_URL}/api/track/product-click`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          phone_number: phoneNumber,
          visitor_id: this.visitorId,
          session_id: this.sessionId,
          product_data: productData
        })
      });

      const data = await response.json();
      console.log('Product click tracked:', data);
      return data;
    } catch (error) {
      console.error('Error tracking product click:', error);
    }
  }


  // Get shopping list analytics
  getShoppingListActivity(phoneNumber, listId = null, startDate = null, endDate = null) {
    let url = `${API_BASE_URL}/api/analytics/shopping-list-activity/${phoneNumber}`;
    const params = new URLSearchParams();

    if (listId) params.append('list_id', listId);
    if (startDate) params.append('start_date', startDate);
    if (endDate) params.append('end_date', endDate);

    if (params.toString()) {
      url += `?${params.toString()}`;
    }

    return axios.get(url);
  }
}

export const shoppingListTrackingService = new ShoppingListTrackingService();